import React from 'react'
import { Dialog } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { useTranslation } from 'react-i18next'
import { DialogView } from '../../../../components/DialogView'

export const CameraPermissionInstructionsDialog = ({
  open,
  setOpen,
  onReload = () => window.location.reload(),
}) => {
  const { t } = useTranslation()

  return (
    <DialogView open={open} setOpen={setOpen} closeOnBackdrop className="sm:max-w-lg sm:w-full">
      <div className="relative">
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label={t('generate_shipment.camera_permission_instructions.close_aria')}
          className="absolute top-0 right-0 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded-md"
        >
          <XIcon className="h-5 w-5" aria-hidden="true" />
        </button>

        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900 pr-8">
          {t('generate_shipment.camera_permission_instructions.dialog_title')}
        </Dialog.Title>

        <p className="mt-3 text-sm text-gray-600">
          {t('generate_shipment.camera_permission_instructions.intro')}
        </p>

        <div className="mt-4 flex justify-center">
          <img
            src="/camera-permission-chrome.gif"
            loading="lazy"
            alt=""
            aria-hidden="true"
            className="max-w-full h-auto rounded-md border border-gray-200"
          />
        </div>

        <ol className="mt-4 list-decimal list-inside space-y-2 text-sm text-gray-700">
          <li>{t('generate_shipment.camera_permission_instructions.step_1')}</li>
          <li>{t('generate_shipment.camera_permission_instructions.step_2')}</li>
          <li>{t('generate_shipment.camera_permission_instructions.step_3')}</li>
        </ol>

        <p className="mt-3 text-xs italic text-gray-500">
          {t('generate_shipment.camera_permission_instructions.browser_note')}
        </p>

        <div className="mt-6">
          <button
            type="button"
            onClick={onReload}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            {t('generate_shipment.camera_permission_instructions.reload_button')}
          </button>
          <p className="mt-2 text-xs text-amber-700 text-center">
            {t('generate_shipment.camera_permission_instructions.reload_warning')}
          </p>
        </div>
      </div>
    </DialogView>
  )
}
